// extracted by mini-css-extract-plugin
export default {"white-background":"BanksPaticipation_white-background__a2Fnu","main":"BanksPaticipation_main__jxIE+","main_container":"BanksPaticipation_main_container__0cpHY"};